import React from 'react';
import {Link} from 'react-router';

import './DoctorDetail.scss';

class DoctorDetail extends React.PureComponent {
  renderInfo = () => {
    const info = this.props.doctor.info;

    if (info) {
      return info.map((item, index) => <li key={index}>{item}</li>)
    }
  };

  renderVideo = () => {
    if (this.props.doctor.video) {
      return (
        <div className="docDetail_video">
          <iframe width="854" height="480" src={"https://www.youtube.com/embed/" + this.props.doctor.video}
                  frameBorder="0" allowFullScreen/>
        </div>
      )
    }
  };

  render() {
    const doctor = this.props.doctor;

    return (
      <section className="docDetail">
        <div className="container relative">
          <Link to="/lekari" className="backwardsBtn"><i className="llc-keyboard-right-arrow-button"/></Link>

          <div className="docDetail_name">{doctor.name}</div>
          <div className="docDetail_text">{doctor.text}</div>
          <ul>{this.renderInfo()}</ul>
          {this.renderVideo()}
        </div>
      </section>
    );
  }
}

export default DoctorDetail;


// WEBPACK FOOTER //
// ./src/components/Doctors/DoctorDetail/DoctorDetail.js